
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import { QuickOrderPositionDto } from "@/dtos/quickOrderPositionDto";
import { QuickInvoiceDto } from "@/dtos/quickInvoiceDto";
import { CustomerInfoDto } from "@/dtos/customerInfoDto";
import PositionComponent from "./Position.vue";

@Component({
	components: {
		"position-component": PositionComponent,
	},
})
export default class QuickOrder extends Vue {
	@Prop() private customerId!: number;
	private customer: CustomerInfoDto | null = null;
	private loading: boolean = false;
	private positions: QuickOrderPositionDto[] = [];
	private comment: string = "";
	private valid: boolean = false;

	private mounted() {
		this.loadCustomer();
	}

	private async loadCustomer() {
		try {
			this.loading = true;
			const response = await httpClient().get(
				`customer/getCustomerInfoById?customerId=${this.customerId}`
			);
			this.customer = response.data;
		} catch {
			console.log("Load customer failed.");
		} finally {
			this.loading = false;
		}
	}

	private async save() {
		try {
			this.loading = true;
			var order = new QuickInvoiceDto();
			order.comment = this.comment;
			order.customerId = this.customerId;
			order.positions = this.positions;
			await httpClient().post(`customerOrder/createQuickInvoice`, order);
			history.back();
		} catch {
			console.log("Save order failed.");
		} finally {
			this.loading = false;
		}
	}

	private addPosition() {
		var newPosition = new QuickOrderPositionDto();
		newPosition.position = this.positions.length + 1;
		this.positions.push(newPosition);
	}
}
